import { defineStore } from "pinia";
import { ref } from "vue";
import type {
  ProcessedCommentaryComment,
  ProcessedCommentaryImage,
} from "@/composables/processCommentarySearchResults/types";

/**
 * A pinia store to keep track of the last comment list displayed to the user,
 * and let easyly use modale comment
 */
export const useLastCommentListStore = defineStore(
  "lastCommentList",
  () => {
    /**
     * The list of processed Comments
     */
    const commentList =
      ref<(ProcessedCommentaryComment | ProcessedCommentaryImage)[]>();

    function $reset() {
      commentList.value = [];
    }

    return {
      commentList,

      clear(): void {
        $reset();
      },

      setList(
        comments: (ProcessedCommentaryComment | ProcessedCommentaryImage)[],
      ): void {
        commentList.value = comments;
      },

      $reset,
    };
  },
  {
    persist: false,
  },
);

export type LastCommentListStore = ReturnType<typeof useLastCommentListStore>;
